import { Router, CanMatchFn, RedirectCommand } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { map, take } from 'rxjs';
import { IsUser } from '../../interfaces/is-user';
import { RouteSegments } from '../../types/route-segments';
import { UserService } from '../../services/user.service';
import { UserOptions } from '../../types/user-options';

export const unAuthGuard: CanMatchFn = () => {
	const router = inject(Router);
	const authService: AuthService = inject(AuthService);
	const userService: UserService = inject(UserService);

	return authService.user.pipe(
		take(1),
		map((user: IsUser | undefined) => {
			if (user) {
				//  User is authenticated, redirect to order
				if (userService.userHasOption(user, UserOptions.ORDER_OVERVIEW_PORTAL)) {
					return new RedirectCommand(router.parseUrl(RouteSegments.OVERVIEW));
				} else {
					return new RedirectCommand(router.parseUrl(RouteSegments.ORDER));
				}
			} else {
				// User is not authenticated
				return true;
			}
		})
	);
};
